import { FC } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const FormConfigSection: FC = () => {
	return (
		<Grid item xs={12}>
			<Box
				sx={{
					border: 1,
					borderColor: "divider",
					borderRadius: 1,
					p: 3,
					mt: 1,
					backgroundColor: "action.hover",
					display: "flex",
					alignItems: "center",
					gap: 1.5,
				}}
			>
				<InfoOutlinedIcon color="disabled" />
				<Typography variant="body2" color="text.secondary">
					Survey configuration will be added in a future update.
				</Typography>
			</Box>
		</Grid>
	);
};
